module.exports = __webpack_public_path__ + "static/img/live_weixin_en.a4d86ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/live_weixin_en.png
// module id = ACvk
// module chunks = 0